<div>
  <div class="row m-2 variance-modal-links" style="padding-top:5px">
    <div class="col-auto">
      <p-button label="Information" styleClass="p-button-rounded p-button-info p-button-sm" (click)="openTab(1)" [style]="{'margin-right': '5px'}"></p-button>
    </div>
    <div class="col-auto">
      <div>
        <p-button label="Documents" styleClass="p-button-rounded p-button-info p-button-sm" (click)="openTab(2)"></p-button>
        <span class="badge badge-light"> {{ totalCount }} </span>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="documentService.tab===2">
    <div class="col-auto">
      <app-browse-documents [record]="selectedRow" (valueChange)='updateDocumentCount($event)'></app-browse-documents>
    </div>
  </div>
  <div class="row" *ngIf="documentService.tab===3">
    <div class="col-auto">
      <app-upload-document [record]="selectedRow" (updateValue)='updateCount($event)'></app-upload-document>
    </div>
  </div>
  <div class="row m-2 p-2" [hidden]="documentService.tab!==1">
    <div class="row w-100">
      <div class="col-md-12 text-center my-2">
      </div>
      <div class="col-md-6">
        <ul class="maap-modal-list">
          <li><span class="maap-title">Name:</span><span class="maap-title-value">{{ isDeId(formatName(selectedRow?.patientName)) }}</span></li>
          <li><span class="maap-title">Patient Id:</span><span class="maap-title-value">{{ isDeId(selectedRow?.mrnNum) }}</span></li>
          <li><span class="maap-title">Medication:</span><span class="maap-title-value">{{ selectedRow?.medDesc }}</span></li>
          <li><span class="maap-title">Stock Area:</span><span class="maap-title-value">{{ selectedRow?.loc }}</span></li>
          <li><span class="maap-title">Variance:</span><span class="maap-title-value">{{ selectedRow?.var | formatQuantity }}</span></li>
          <li><span class="maap-title">Unit of Measure:</span><span class="maap-title-value">{{ selectedRow?.uom }}</span></li>
          <li><span class="maap-title">Source:</span><span class="maap-title-value">Variance</span></li>
          <li><span class="maap-title">Date/Time:</span><span class="maap-title-value">{{ formatDateCustom(selectedRow.varDateString) }}</span></li>
          <li><span class="maap-title">Variance Type:</span><span class="maap-title-value">{{ selectedRow?.resolutionCoding }}</span></li>
          <li><span class="maap-title">Role:</span><span class="maap-title-value">{{ selectedRow?.serviceGroup }}</span></li>
          <li><span class="maap-title">Practice Issue:</span><span class="maap-title-value">{{selectedRow?.practiceIssue}}</span></li>
        </ul>
        <hr />
        <h4 class="maap-title-2">History</h4>
        <div [class]="getHistoryBlurClass() + ' history-panel'" style="height:250px;width:100%;padding:10px;overflow:auto;">
          <div *ngFor="let comment of comments">
            <p style="white-space: pre-line">
              {{ comment["createdAt"] | date: "MM/dd/yyyy | HH:mm" }} <br>
              {{ !!comment["userAction"] ? comment["userAction"] : "" }}
            </p>
            <p>{{ comment["status"] }} - {{ comment["comment"] }}</p>
            <p class="font-weight-bold" style="text-align: right">{{ comment["authorName"] }}</p>
            <br />
          </div>
          <div>
            <p>{{selectedRow?.createdAt | date : 'MM/dd/yyyy | HH:mm'}} - {{ selectedRow?.resCode || selectedRow?.resolutionCoding }}</p>
            <p class="font-weight-bold" style="text-align:right">Assigned by Software</p>
            <br />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-lg-8">
            <div class="form-group">
              <div class="col-lg-3 pl-0">
                <div class="form-group mt-4">
                  <h4 class="maap-title-2">Verified</h4>
                  <p-select [options]="[{label: 'Yes', value: true}, {label: 'No', value: false}]" [(ngModel)]="transType" [style]="{'width':'120px'}"></p-select>
                </div>
              </div>
              <h4 class="maap-title-2" id="resolution">Variance</h4>
                <p-select [options]="resolutionOptions" [(ngModel)]="resCoding" [filter]="true" placeholder="Update Variance Type" [styleClass]="'change-status-dropdown-sm w-100'">
                  <ng-template let-item pTemplate="selectedItem">
                    <span style="vertical-align: middle; margin-left: 0.5em">{{ item.label }}</span>
                  </ng-template>
                  <ng-template let-followup pTemplate="item">
                    <div class="ui-helper-clearfix" style="position: relative; height: auto">
                      <div style="float: center; margin-top: 4px">{{ followup.label }}</div>
                    </div>
                  </ng-template>
                </p-select>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="form-group">
              <h4 class="maap-title-2">Practice Issue</h4>
              <p-multiSelect name="practiceIssue" [styleClass]="'change-status-practice-issue'" [options]="practiceIssueOptions" [(ngModel)]="practiceIssue" filter="true" placeholder="Practice Issue" styleClass="dds" [style]="{'width':'275px'}"></p-multiSelect>
            </div>
          </div>
        </div>
        <div class="form-group">
          <h4 class="maap-title-2">Comment</h4>
          <app-mention-editor [(value)]="comment" [(taggedUsers)]="taggedUsers"
            [users]="userMentions" [minRows]="10"></app-mention-editor>
        </div>
      </div>
      <div class="col-md-12">
        <p class="font-weight-bold float-left">{{lockMessage}}</p>
        <p-footer>
          <div style="display: flex; justify-content: flex-end; gap: 8px;">
            <p-button label="Cancel" styleClass="p-button-sm" (click)="closeDialog()"></p-button>
            <p-button label="Submit" styleClass="p-button-sm" (click)="submit()" [disabled]="isLocked"></p-button>
          </div>
        </p-footer>
      </div>
    </div>
  </div>
</div>
